const state = {
  ratings: {},
  pageCounter: 0,
}

const getters = {
  ratings: (state) => (agendumId) => {
    return state.ratings[agendumId] || []
  },

  pageCounter: (state) => {
    return state.pageCounter
  },

  userRating: (state) => (agendumId, userId) => {
    const ratings = state.ratings[agendumId] || []
    return ratings.find(rating => rating.relations?.user?.id === userId)
  },
}

const actions = {
  async createRating({ dispatch, commit }, { agendumId, form }) {
    const endpoint = `/agendums/${agendumId}/rating`
    return form.post(endpoint, true)
  },

  async updateRating({ dispatch, commit }, { agendumId, ratingId, form }) {
    const endpoint = `/agendums/${agendumId}/rating/${ratingId}`
    return form.post(endpoint, true)
  },

  async deleteRating({ dispatch, commit }, { agendumId, ratingId }) {
    const endpoint = `/agendums/${agendumId}/rating/${ratingId}`
    const response = await this._vm.$api.delete(endpoint)

    if (response.data.success) {
      commit('removeRating', { agendumId, ratingId })
    }

    return response
  },

  async getRatings({ dispatch, commit }, { agendumId, params = {} }) {
    const endpoint = `/agendums/${agendumId}/ratings`
    const response = await this._vm.$api.get(endpoint, { params })

    if (response.data.success) {
      commit('setRatings', { agendumId, ratings: response.data.data })
    }

    return response
  },
}

const mutations = {
  setRatings(state, { agendumId, ratings }) {
    state.ratings = {
      ...state.ratings,
      [agendumId]: ratings
    }
  },

  addRating(state, { agendumId, rating }) {
    if (!state.ratings[agendumId]) {
      state.ratings[agendumId] = []
    }
    state.ratings[agendumId].unshift(rating)
  },

  updateRating(state, { agendumId, ratingId, rating }) {
    if (state.ratings[agendumId]) {
      const index = state.ratings[agendumId].findIndex(r => r.id === ratingId)
      if (index !== -1) {
        state.ratings[agendumId].splice(index, 1, rating)
      }
    }
  },

  removeRating(state, { agendumId, ratingId }) {
    if (state.ratings[agendumId]) {
      state.ratings[agendumId] = state.ratings[agendumId].filter(r => r.id !== ratingId)
    }
  },

  setPageCounter(state, value) {
    state.pageCounter = value
  },

  incrementPageCounter(state) {
    state.pageCounter++
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
